import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Revision = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M15.975 5L12 2v2a8.94 8.94 0 0 0-6.364 2.636A8.94 8.94 0 0 0 3 13c0 2.404.936 4.664 2.636 6.363C7.336 21.063 9.596 22 12 22s4.664-.937 6.363-2.637A8.938 8.938 0 0 0 21 13h-2c0 1.87-.729 3.627-2.051 4.949S13.87 20 12 20c-1.87 0-3.627-.729-4.95-2.051S5 14.87 5 13c0-1.87.728-3.627 2.05-4.95S10.13 6 12 6v2l3.975-3z", key: "k0" })));
});
Revision.displayName = 'Revision';
export var RevisionDimensions = { height: 24, width: 24 };
